import { createReducer, INITIAL_STATE } from '@shared/redux';

export const OPEN_GOALS_MANAGEMENT_MODAL = '@goalsManagementModal/OPEN_GOALS_MANAGEMENT_MODAL';
export const CLOSE_GOALS_MANAGEMENT_MODAL = '@goalsManagementModal/CLOSE_GOALS_MANAGEMENT_MODAL';

export const getIsGoalsManagementModalOpen = state => (
    state.goals.goalsManagementModal.isGoalsManagementModalOpen
);


export const openGoalsManagementModal = () => ({
    type: OPEN_GOALS_MANAGEMENT_MODAL,
    payload: {},
});

export const closeGoalsManagementModal = () => ({
    type: CLOSE_GOALS_MANAGEMENT_MODAL,
    payload: {},
});

const initialState = {
    isGoalsManagementModalOpen: false,
};

export const goalsManagementModalReducer = createReducer({
    [INITIAL_STATE]: initialState,
    [OPEN_GOALS_MANAGEMENT_MODAL]: state => ({
        ...state,
        isGoalsManagementModalOpen: true,
    }),
    [CLOSE_GOALS_MANAGEMENT_MODAL]: state => ({
        ...state,
        isGoalsManagementModalOpen: false,
    }),
});
